import { useEffect, useRef, useState } from 'react';
import { LANGS, type Lang, t } from '../i18n/i18n';
import { useApp } from '../state/store';
import { setLanguage } from './actions';
import { IconGear } from './icons';

/** Gear button at the bottom of the tool bar: app settings (language). */
export function SettingsMenu() {
  const lang = useApp((s) => s.lang);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('pointerdown', close);
    window.addEventListener('keydown', esc);
    return () => {
      window.removeEventListener('pointerdown', close);
      window.removeEventListener('keydown', esc);
    };
  }, [open]);
  return (
    <div className="settings" ref={ref}>
      <button className="tool" aria-label={t('Settings')} title={t('Settings')} aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen(!open)}>
        <IconGear size={18} />
      </button>
      {open && (
        <div className="settings-menu" role="menu" aria-label={t('Settings')}>
          <div className="settings-title">{t('Language')}</div>
          {LANGS.map((l) => (
            <button
              key={l.id}
              role="menuitemradio"
              aria-checked={lang === l.id}
              className={'settings-item' + (lang === l.id ? ' active' : '')}
              onClick={() => {
                setLanguage(l.id as Lang);
                setOpen(false);
              }}
            >
              <span className="check-mark">{lang === l.id ? '✓' : ''}</span> {l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
